<section>
    <div class="info">
        <div class="info-icon">
            <xm-media-image aria-hidden="true" [imageOptions]="imageOptions" size="auto"></xm-media-image>
        </div>
        <div class="data">
            <h4 class="header">{{ pageData.header }}</h4>
            <p class="subheader">{{ pageData.subheader }}</p>
            <p class="description">{{ pageData.description }}</p>
        </div>
        <div class="btn-action">
            <cms-text class="broadband-links-desktop" [originalText]="pageData.cta" [disableClick]="shouldDisableButton"></cms-text>
        </div>
    </div>
</section>
